import { Header } from "@general-backoffice/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import useGoogleCalcTable from "../../../../hooks/useGoogleCalcTable";

interface MaterialsProps {
  sheets?: string;
  sheet?: string;
}

interface MaterialCardProps {
  title?: string;
  description?: string;
  url?: string;
}

const Materials: React.FC<MaterialsProps> = ({ sheets = "1bUnXsOc7wQL3Uwpo0aKScmsH1eWhBKA_CRbLATJbclM", sheet }) => {
  const { i18n } = useTranslation("info");
  const { data, loading } = useGoogleCalcTable(sheets, sheet);

  return (
    <Header.BreadCrumb color="secondary" isDark={false}>
      <Container fluid>
        <Row>
          {loading ? (
            <p className="mx-auto mt-6">Loading...</p>
          ) : (
            data?.map((material, i) => (
              <Col key={i} xs={12} sm={6} xl={4} className="mb-4">
                <MaterialCard
                  key={i}
                  title={material[`title_${i18n.language}`] || material["title_en"]}
                  description={material[`description_${i18n.language}`] || material["description_en"]}
                  url={material?.url}
                />
              </Col>
            ))
          )}
        </Row>
      </Container>
    </Header.BreadCrumb>
  );
};

const MaterialCard: React.FC<MaterialCardProps> = ({ title, description, url }) => (
  <Card className="mb-0 h-100 card-link" tag="a" href={url} target="_blank" rel="noreferrer">
    <CardBody className="d-flex flex-column justify-content-between">
      {title && <h3 className="font-weight-bold text-default pr-3">{title}</h3>}
      <div className="d-flex justify-content-between align-items-end">
        <span className="text-muted text-sm">{description}</span>
        {url && (
          <a href={url} className="btn btn-primary mt-3 ml-4" target="_blank" rel="noreferrer">
            <i className="fas fa-external-link-alt"></i>
          </a>
        )}
      </div>
    </CardBody>
  </Card>
);

export default Materials;
